import { useMemo } from "react";

import { BucketOfLearninRow } from "./BucketOfLearninRow";
import { useLevelContext } from "sj-ui-toolkit/src/atlas/contexts/Level/LevelContextProvider";

export const QuestBucket = ({ currentQuests = [] }) => {
  const { quests, questsLoading } = useLevelContext();

  const notEnrolledQuests = useMemo(() => {
    const enrolledRoleIds = new Set(currentQuests.map(q => q.id));
    return quests.filter(quest => !enrolledRoleIds.has(quest.role?.id));
  }, [quests, currentQuests]);

  return (
    <div className="my-8">
      <BucketOfLearninRow
        key="quest-row"
        id="quest"
        name="Quests"
        variant="indigo"
        loading={questsLoading}
        learnins={notEnrolledQuests}
        pathType="Quest"
      />
    </div>
  );
};
